import React from 'react';

import { ADGMAlert } from 'aurora-components';
import { keyEmptyCheck } from 'aurora-utils/utils';

import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

import styles from './styles';

//-----------------------------------------

function AutoCancellationBar({ classes }) {
  return (
    <ADGMAlert type='error' className={classes.main}>
      {keyEmptyCheck('auto_cancelled_reason_inactivity')}
    </ADGMAlert>
  );
}

AutoCancellationBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AutoCancellationBar);
